import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BeWomanLogo } from "@/components/BeWomanLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/app/home";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleButton({ testId = "google-login-btn" }) {
  return (
    <button
      type="button"
      onClick={googleLogin}
      data-testid={testId}
      className="w-full bg-white text-[#F6DCEA] border border-[#E32C8C]/35 bw-card font-semibold py-3.5 px-6 rounded-full hover:bg-[#2A0A1B] transition-all flex items-center justify-center gap-3 shadow-sm"
    >
      <svg className="w-5 h-5" viewBox="0 0 48 48">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 18.9 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.6 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.4l6.2 5.2C41.1 35.7 44 30.3 44 24c0-1.3-.1-2.3-.4-3.5z"/>
      </svg>
      Continua con Google
    </button>
  );
}

export function AuthShell({ title, subtitle, children, onBack }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[100dvh] bg-[#00000000]">
      <div className="max-w-md mx-auto min-h-[100dvh] px-6 py-8 flex flex-col">
        <button
          onClick={() => (onBack ? onBack() : navigate("/"))}
          data-testid="auth-back-btn"
          className="self-start flex items-center gap-1.5 text-[#EAC6D9] text-sm font-medium mb-4"
        >
          <ArrowLeft className="w-4 h-4" /> Indietro
        </button>
        <div className="flex-1 flex flex-col justify-center bw-fade">
          <BeWomanLogo size="medium" className="mb-6" />
          <h1 className="font-serif text-4xl font-bold text-[#F6DCEA] text-center">{title}</h1>
          <p className="text-[#EAC6D9] text-center mt-2 mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
